const cs = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Načítání...',
    error: 'Chyba',
    save: 'Uložit',
    cancel: 'Zrušit',
    delete: 'Smazat',
    edit: 'Upravit',
    create: 'Vytvořit',
    add: 'Přidat',
    remove: 'Odebrat',
    close: 'Zavřít',
    confirm: 'Potvrdit',
    apply: 'Použít',
    reset: 'Obnovit',
    search: 'Hledat',
    filter: 'Filtr',
    clear: 'Vymazat',
    back: 'Zpět',
    next: 'Další',
    previous: 'Předchozí',
    submit: 'Odeslat',
    update: 'Aktualizovat',
    refresh: 'Obnovit',
    export: 'Exportovat',
    import: 'Importovat',
    download: 'Stáhnout',
    upload: 'Nahrát',
    print: 'Tisk',
    copy: 'Kopírovat',
    yes: 'Ano',
    no: 'Ne',
    ok: 'OK',
    done: 'Hotovo',
    select: 'Vybrat',
    selectAll: 'Vybrat vše',
    deselectAll: 'Zrušit výběr',
    noResults: 'Nebyly nalezeny žádné výsledky',
    noData: 'Žádná data nejsou k dispozici',
    required: 'Povinné',
    optional: 'Volitelné',
    actions: 'Akce',
    details: 'Podrobnosti',
    overview: 'Přehled',
    summary: 'Souhrn',
    total: 'Celkem',
    all: 'Vše',
    none: 'Žádné',
    name: 'Název',
    type: 'Typ',
    status: 'Stav',
    date: 'Datum',
    time: 'Čas',
    description: 'Popis',
    notes: 'Poznámky',
    comments: 'Komentáře',
    category: 'Kategorie',
    priority: 'Priorita',
    nation: 'Stát',
    country: 'Země',
    email: 'E-mail',
    phone: 'Telefon',
    address: 'Adresa',
    location: 'Umístění',
    coordinates: 'Souřadnice',
    latitude: 'Zeměpisná šířka',
    longitude: 'Zeměpisná délka',
    from: 'Od',
    to: 'Do',
    createdAt: 'Vytvořeno',
    updatedAt: 'Aktualizováno',
    createdBy: 'Vytvořil',
    modifiedBy: 'Upravil',
    active: 'Aktivní',
    inactive: 'Neaktivní',
    enabled: 'Povoleno',
    disabled: 'Zakázáno',
    showing: 'Zobrazeno',
    of: 'z',
    page: 'Stránka',
    perPage: 'na stránku',
    rows: 'řádků',
    items: 'položek',
    results: 'výsledků',
    sortBy: 'Řadit podle',
    ascending: 'Vzestupně',
    descending: 'Sestupně',
    viewAll: 'Zobrazit vše',
    viewDetails: 'Zobrazit podrobnosti',
    goBack: 'Zpět',
    learnMore: 'Zjistit více',
    seeMore: 'Zobrazit více',
    showMore: 'Zobrazit více',
    showLess: 'Zobrazit méně',
    expandAll: 'Rozbalit vše',
    collapseAll: 'Sbalit vše',
    copied: 'Zkopírováno!',
    saved: 'Uloženo!',
    deleted: 'Smazáno!',
    updated: 'Aktualizováno!',
    created: 'Vytvořeno!',
    success: 'Úspěch',
    warning: 'Varování',
    info: 'Informace',
    danger: 'Nebezpečí',
    unknown: 'Neznámé',
    notAvailable: 'Nedostupné',
    never: 'Nikdy',
    today: 'Dnes',
    yesterday: 'Včera',
    tomorrow: 'Zítra',
    now: 'Nyní',
    ago: 'zpět',
    justNow: 'právě teď',
    minutesAgo: 'před {{count}} min',
    hoursAgo: 'před {{count}} hod',
    daysAgo: 'před {{count}} dny',
    monthsAgo: 'před {{count}} měs',
    id: 'ID',
    version: 'Verze',
    language: 'Jazyk',
    theme: 'Vzhled',
    darkMode: 'Tmavý režim',
    lightMode: 'Světlý režim',
    failedToLoad: 'Nepodařilo se načíst data',
    failedToSave: 'Nepodařilo se uložit',
    failedToDelete: 'Nepodařilo se smazat',
    failedToUpdate: 'Nepodařilo se aktualizovat',
    confirmDelete: 'Opravdu chcete tuto položku smazat?',
    confirmAction: 'Jste si jisti?',
    unsavedChanges: 'Máte neuložené změny. Opravdu chcete odejít?',
    pageNotFound: '404 – Stránka nenalezena',
    pageNotFoundDesc: 'Stránka, kterou hledáte, neexistuje.',
    backToDashboard: 'Zpět na přehled',
    characters: 'znaků',
    maxCharacters: 'Maximálně {{max}} znaků',
    remaining: 'zbývá {{count}}',
    selected: '{{count}} vybráno',
    of_total: '{{count}} z {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Přehled',
    requests: 'Žádosti',
    transports: 'Transporty',
    myPatients: 'Moji pacienti',
    statistics: 'Statistiky',
    flow: 'Tok',
    resources: 'Resources',
    exercise: 'Cvičení',
    administration: 'Administrace',
    map: 'Mapa',
    info: 'Informace',
    users: 'Uživatelé',
    assets: 'Prostředky',
    hubs: 'Uzly',
    treatmentFacilities: 'Zdravotnická zařízení',
    patientImport: 'Import pacientů',
    assetTemplates: 'Šablony prostředků',
    dayTemplates: 'Denní šablony',
    announcementTicker: 'Ticker oznámení',
    exerciseStatistics: 'Statistiky cvičení',
    settings: 'Nastavení',
    auditLog: 'Auditní protokol',
    exerciseControl: 'Řízení cvičení',
    dataSync: 'Synchronizace dat',
    documentation: 'Dokumentace',
    support: 'Podpora',
    about: 'O systému',
    assetContracts: 'Asset Contracts',
    notifications: 'Oznámení',
    schedules: 'Jízdní řády',
    capacityPlanning: 'Plánování kapacit',
    transportPlanning: 'Plánování transportu',
    transportBooking: 'Rezervace transportu',
    flowDiagram: 'Diagram toku',
    changePassword: 'Změna hesla',
    missions: 'Mise',
    startPoints: 'Výchozí body',
    hospital: 'Nemocnice',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Přihlásit se',
    logout: 'Odhlásit se',
    logoutNow: 'Odhlásit nyní',
    loggingIn: 'Přihlašování...',
    loginFailed: 'Přihlášení se nezdařilo',
    email: 'E-mail',
    password: 'Heslo',
    username: 'Uživatelské jméno',
    enterEmail: 'Zadejte svou e-mailovou adresu',
    enterPassword: 'Zadejte své heslo',
    enterUsername: 'Zadejte své uživatelské jméno',
    forgotPassword: 'Zapomněli jste heslo?',
    forgotPasswordTitle: 'Zapomenuté heslo',
    forgotPasswordDesc: 'Zadejte své uživatelské jméno a e-mailovou adresu. Pokud se oba údaje shodují, administrátoři budou informováni o žádosti o obnovení hesla.',
    requestPasswordReset: 'Požádat o obnovení hesla',
    sending: 'Odesílání...',
    backToLogin: 'Zpět na přihlášení',
    pleaseWait: 'Před dalším pokusem prosím vyčkejte.',
    requestFailed: 'Žádost se nezdařila',
    credentialsMatch: 'Pokud se přihlašovací údaje shodují, administrátoři byli informováni.',
    forAccess: 'Pro získání přístupu kontaktujte prosím správce systému.',
    changePassword: 'Změna hesla',
    currentPassword: 'Aktuální heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrzení hesla',
    passwordChanged: 'Heslo bylo úspěšně změněno',
    passwordMismatch: 'Hesla se neshodují',
    passwordTooShort: 'Heslo musí mít alespoň 8 znaků',
    changingPassword: 'Měním heslo...',
    mustChangePassword: 'Před pokračováním musíte změnit své heslo.',
    sessionExpiring: 'Relace brzy vyprší',
    sessionExpireText: 'Vaše relace vyprší za <strong>{{time}}</strong>. Uložte prosím svou práci a znovu se přihlaste.',
    dismiss: 'Zavřít',
    switchNation: 'Přepnout stát',
    returnTo: 'Vrátit se k {{nation}}',
    viewingAs: 'Prohlížíte jako',
    loggedInAs: 'přihlášen jako {{nation}}',
    trainingMode: 'POUZE PRO ÚČELY VÝCVIKU',
    dedication: 'Vytvořeno s láskou a oddaností profesi',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Správce systému',
    excon: 'Řídící cvičení',
    eu: 'Koordinátor EU',
    planner: 'Plánovač',
    hub: 'Správce uzlu',
    nation: 'Stát',
    readOnly: 'Pouze ke čtení',
    systemAdmin: 'Správce systému',
    transportPlanner: 'Plánovač transportu',
    systemRoles: 'Systémové role',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Koncept',
    underReview: 'V přezkumu',
    published: 'Publikováno',
    underSelection: 'Ve výběru',
    accepted: 'Přijato',
    planned: 'Naplánováno',
    inTransit: 'Na cestě',
    completed: 'Dokončeno',
    closed: 'Uzavřeno',
    withdrawn: 'Staženo',
    pending: 'Čeká na vyřízení',
    rejected: 'Zamítnuto',
    cancelled: 'Zrušeno',
    active: 'Aktivní',
    inactive: 'Neaktivní',
    review: 'Přezkum',
    selection: 'Výběr',
    transit: 'Na cestě',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personál',
    material: 'Materiál',
    equipment: 'Vybavení',
    other: 'Ostatní',
    news: 'Zprávy',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Běžná',
    priority: 'Prioritní',
    urgent: 'Naléhavá',
    immediate: 'Okamžitá',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Vlak',
    ship: 'Loď',
    aircraft: 'Letadlo',
    bus: 'Autobus',
    ambulance: 'Sanitka',
    drone: 'Dron',
    helicopter: 'Vrtulník',
    ferry: 'Trajekt',
    other: 'Ostatní',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Přehled',
    goodMorning: 'Dobré ráno',
    goodAfternoon: 'Dobré odpoledne',
    goodEvening: 'Dobrý večer',
    lastLogin: 'Poslední přihlášení',
    infrastructure: 'Infrastruktura',
    transportAssets: 'Transportní prostředky',
    treatmentFacilities: 'Zdravotnická zařízení',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistiky žádostí',
    viewAllRequests: 'Zobrazit všechny žádosti',
    availableAssets: 'Dostupné prostředky',
    seated: 'Sedící',
    lying: 'Ležící',
    intensive: 'Intenzivní',
    notifications: 'Oznámení',
    markAllRead: 'Označit vše jako přečtené',
    noNotifications: 'Zatím žádná oznámení',
    notifiedWhenActivity: 'Budete upozorněni při nové aktivitě',
    viewDetailsBtn: 'Zobrazit podrobnosti',
    nationUsers: 'Uživatelé státu',
    user: 'Uživatel',
    roles: 'Role',
    noUsersFound: 'Nebyli nalezeni žádní uživatelé',
    participatingNations: 'Zúčastněné státy',
    exerciseDisclaimer: 'Tento systém je určen pouze pro cvičení. Zadávejte výhradně simulovaná cvičební data. Pracovní postupy jsou přizpůsobeny scénáři cvičení a mohou se lišit od skutečných postupů. Pravidla IT bezpečnosti a ochrany dat zůstávají plně v platnosti.',
    notConfigured: 'Nenastaveno',
    requestCount: '{{count}} žádost(í)',
    clickToView: 'Klikněte pro zobrazení',
    systemAdministration: 'Správa systému',
    exerciseControlTitle: 'Řízení cvičení',
    euCoordination: 'Koordinace EU',
    transportPlanningTitle: 'Plánování transportu',
    hubManagement: 'Správa uzlů',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nová žádost',
    myDrafts: 'Moje koncepty',
    pendingReview: 'Čeká na přezkum',
    activeTransports: 'Aktivní transporty',
    myPatients: 'Moji pacienti',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Žádosti',
    newRequest: 'Nová žádost',
    createRequest: 'Vytvořit žádost',
    editRequest: 'Upravit žádost',
    requestDetail: 'Detail žádosti',
    requestId: 'ID žádosti',
    fromNation: 'Od státu',
    toNation: 'Pro stát',
    requestingNation: 'Žádající stát',
    receivingNation: 'Přijímající stát',
    category: 'Kategorie',
    urgency: 'Naléhavost',
    status: 'Stav',
    patients: 'Pacienti',
    patientCount: 'Počet pacientů',
    offers: 'Nabídky',
    offerCount: 'Počet nabídek',
    created: 'Vytvořeno',
    updated: 'Aktualizováno',
    submittedBy: 'Odesláno uživatelem',
    reviewedBy: 'Přezkoumal',
    description: 'Popis',
    medicalDetails: 'Zdravotní údaje',
    transportDetails: 'Detaily transportu',
    additionalInfo: 'Doplňující informace',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Místo odjezdu',
    arrivalPoint: 'Místo příjezdu',
    estimatedDeparture: 'Odhadovaný odjezd',
    estimatedArrival: 'Odhadovaný příjezd',
    submitForReview: 'Odeslat k přezkumu',
    publish: 'Publikovat',
    startSelection: 'Zahájit výběr',
    acceptOffer: 'Přijmout nabídku',
    markInTransit: 'Označit jako na cestě',
    markCompleted: 'Označit jako dokončeno',
    closeRequest: 'Uzavřít žádost',
    withdrawRequest: 'Stáhnout žádost',
    withdraw: 'Stáhnout',
    revertToDraft: 'Vrátit do konceptu',
    deleteRequest: 'Smazat žádost',
    duplicateRequest: 'Duplikovat žádost',
    createFollowUp: 'Vytvořit konsolidovanou žádost',
    followUpRequest: 'Konsolidovaná žádost',
    parentRequest: 'Původní žádost',
    childRequests: 'Konsolidované žádosti',
    noRequests: 'Nebyly nalezeny žádné žádosti',
    noOffers: 'Zatím žádné nabídky',
    addPatient: 'Přidat pacienta',
    removePatient: 'Odebrat pacienta',
    patientDetails: 'Údaje o pacientovi',
    contactPerson: 'Kontaktní osoba',
    contactPhone: 'Kontaktní telefon',
    contactEmail: 'Kontaktní e-mail',
    specialRequirements: 'Speciální požadavky',
    medicalEquipment: 'Zdravotnické vybavení',
    accompaniment: 'Doprovod',
    timeline: 'Časová osa',
    history: 'Historie',
    addComment: 'Přidat komentář',
    writeComment: 'Napište komentář...',
    postComment: 'Odeslat komentář',
    posting: 'Odesílání...',
    noComments: 'Zatím žádné komentáře',
    coverageBar: 'Pokrytí',
    covered: 'pokryto',
    uncovered: 'nepokryto',
    filterByStatus: 'Filtrovat podle stavu',
    filterByCategory: 'Filtrovat podle kategorie',
    filterByNation: 'Filtrovat podle státu',
    searchRequests: 'Hledat žádosti...',
    confirmWithdraw: 'Opravdu chcete tuto žádost stáhnout?',
    confirmDelete: 'Opravdu chcete tuto žádost smazat?',
    confirmPublish: 'Opravdu chcete tuto žádost publikovat? Bude viditelná pro všechny státy.',
    confirmStartSelection: 'Opravdu chcete zahájit výběr? Státy budou moci podávat nabídky.',
    warningStartSelection: 'Zahájení výběru zpřístupní tuto žádost všem zúčastněným státům. Budou moci podávat nabídky pro pacienty v této žádosti. Tuto akci nelze vzít zpět.',
    warningMakeOffer: 'Odesláním této nabídky se váš stát zavazuje poskytnout navrhovanou pomoc. Tato akce upozorní žádající stát a řízení cvičení.',
    saveDraft: 'Uložit koncept',
    saving: 'Ukládání...',
    saveAndSubmit: 'Uložit a odeslat',
    step: 'Krok {{number}}',
    generalInfo: 'Obecné informace',
    patientInfo: 'Informace o pacientovi',
    logisticsInfo: 'Logistické informace',
    reviewSubmit: 'Přezkum a odeslání',
    requestTitle: 'Název žádosti',
    requestDescription: 'Popis žádosti',
    numberOfPatients: 'Počet pacientů',
    typeOfAssistance: 'Typ pomoci',
    medicalTreatment: 'Lékařské ošetření',
    transportAssistance: 'Transportní pomoc',
    both: 'Obojí',
    treatmentOnly: 'Pouze ošetření',
    transportOnly: 'Pouze transport',
    validationErrors: 'Opravte prosím následující chyby:',
    fieldRequired: 'Toto pole je povinné',
    selectExitHub: 'Vyberte výstupní uzel',
    createExitHub: 'Vytvořit výstupní uzel',
    backToRequests: 'Zpět na žádosti',
    noRequestsFound: 'Nebyly nalezeny žádné žádosti',
    createFirstRequest: 'Vytvořte svou první žádost',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Nabídky',
    createOffer: 'Vytvořit nabídku',
    makeOffer: 'Podat nabídku',
    manageOffers: 'Správa nabídek',
    offerDetail: 'Detail nabídky',
    offerId: 'ID nabídky',
    offeringNation: 'Nabízející stát',
    offerType: 'Typ nabídky',
    treatment: 'Ošetření',
    transport: 'Transport',
    combined: 'Kombinovaná',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Nabídka ošetření',
    transportOffer: 'Nabídka transportu',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Vybrat pacienty',
    selectedPatients: 'Vybraní pacienti',
    patientSelection: 'Výběr pacientů',
    offerConfiguration: 'Konfigurace nabídky',
    reviewOffer: 'Přezkum nabídky',
    submitOffer: 'Odeslat nabídku',
    submitting: 'Odesílání...',
    acceptOffer: 'Přijmout nabídku',
    rejectOffer: 'Zamítnout nabídku',
    withdrawOffer: 'Stáhnout nabídku',
    noOffers: 'Žádné nabídky nejsou k dispozici',
    noOffer: 'No Offer',
    offerStatus: 'Stav nabídky',
    offerDate: 'Datum nabídky',
    transportAsset: 'Transportní prostředek',
    departureDate: 'Datum odjezdu',
    arrivalDate: 'Datum příjezdu',
    treatmentFacility: 'Zdravotnické zařízení',
    capacity: 'Kapacita',
    availableCapacity: 'Dostupná kapacita',
    totalCapacity: 'Celková kapacita',
    selectAsset: 'Vybrat prostředek',
    selectFacility: 'Vybrat zařízení',
    offerNotes: 'Poznámky k nabídce',
    confirmAccept: 'Opravdu chcete tuto nabídku přijmout?',
    confirmReject: 'Opravdu chcete tuto nabídku zamítnout?',
    extendTransport: 'Rozšířit transport',
    transportExtension: 'Rozšíření transportu',
    comparisonView: 'Porovnání',
    shortlist: 'Užší výběr',
    addToShortlist: 'Přidat do užšího výběru',
    removeFromShortlist: 'Odebrat z užšího výběru',
    leaveConfirmTitle: 'Opustit tuto stránku?',
    leaveConfirmMessage: 'Máte neuložené změny. Opravdu chcete odejít?',
    stayOnPage: 'Zůstat na stránce',
    leavePage: 'Opustit stránku',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporty',
    missionDetail: 'Detail transportu',
    missionId: 'ID transportu',
    missionStatus: 'Stav transportu',
    createMission: 'Vytvořit transport',
    overview: 'Přehled',
    patientsTab: 'Pacienti',
    transportsTab: 'Úseky transportu',
    treatmentTab: 'Ošetření',
    reviewTab: 'Přezkum',
    departure: 'Odjezd',
    arrival: 'Příjezd',
    origin: 'Výchozí místo',
    destination: 'Cíl',
    stops: 'Zastávky',
    addStop: 'Přidat zastávku',
    removeStop: 'Odebrat zastávku',
    stopName: 'Název zastávky',
    stopType: 'Typ zastávky',
    estimatedTime: 'Odhadovaný čas',
    actualTime: 'Skutečný čas',
    asset: 'Prostředek',
    driver: 'Řidič',
    crew: 'Posádka',
    noMissions: 'Nebyly nalezeny žádné transporty',
    completeMission: 'Dokončit transport',
    cancelMission: 'Zrušit transport',
    startTransport: 'Zahájit transport',
    missionChain: 'Řetězec transportu',
    linkedMissions: 'Propojené transporty',
    handover: 'Předání',
    handoverPoint: 'Místo předání',
    pickupPoint: 'Místo vyzvednutí',
    dropoffPoint: 'Místo vysazení',
    searchTransports: 'Hledat transporty...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacienti',
    myPatients: 'Moji pacienti',
    patientId: 'ID pacienta',
    firstName: 'Jméno',
    lastName: 'Příjmení',
    dateOfBirth: 'Datum narození',
    age: 'Věk',
    gender: 'Pohlaví',
    male: 'Muž',
    female: 'Žena',
    other: 'Jiné',
    nationality: 'Státní příslušnost',
    diagnosis: 'Diagnóza',
    condition: 'Stav',
    stable: 'Stabilní',
    critical: 'Kritický',
    serious: 'Vážný',
    treatmentNeeded: 'Potřebné ošetření',
    allergies: 'Alergie',
    medications: 'Medikace',
    bloodType: 'Krevní skupina',
    weight: 'Hmotnost (kg)',
    infectious: 'Infekční',
    mentalHealth: 'Duševní zdraví',
    mobility: 'Mobilita',
    ambulatory: 'Pohyblivý',
    wheelchair: 'Invalidní vozík',
    stretcher: 'Nosítka',
    intensive: 'Intenzivní péče',
    oxygenRequired: 'Vyžaduje kyslík',
    ventilator: 'Ventilátor',
    medicalEscort: 'Zdravotnický doprovod',
    noPatients: 'Nebyli nalezeni žádní pacienti',
    patientDetails: 'Údaje o pacientovi',
    medicalHistory: 'Zdravotní anamnéza',
    travelDocuments: 'Cestovní doklady',
    passport: 'Cestovní pas',
    pseudonymizedId: 'Pseudonymizované ID',
    sensitiveData: 'Citlivé údaje',
    journey: 'Cesta pacienta',
    assignedTo: 'Přiřazen k',
    currentLocation: 'Aktuální umístění',
    importPatients: 'Importovat pacienty',
    exportPatients: 'Exportovat pacienty',
    seated: 'Sedící',
    lying: 'Ležící',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Uživatelé',
    createUser: 'Vytvořit uživatele',
    editUser: 'Upravit uživatele',
    deleteUser: 'Smazat uživatele',
    username: 'Uživatelské jméno',
    displayName: 'Zobrazované jméno',
    email: 'E-mail',
    password: 'Heslo',
    role: 'Role',
    roles: 'Role',
    nation: 'Stát',
    active: 'Aktivní',
    lastLogin: 'Poslední přihlášení',
    createdAt: 'Vytvořeno',
    isNation: 'Stát',
    isEU: 'EU',
    isAdmin: 'Správce',
    isExcon: 'EXCON',
    isPlanner: 'Plánovač',
    isHub: 'Uzel',
    isReadOnly: 'Pouze ke čtení',
    noUsers: 'Nebyli nalezeni žádní uživatelé',
    confirmDelete: 'Opravdu chcete tohoto uživatele smazat?',
    resetPassword: 'Obnovit heslo',
    generatePassword: 'Vygenerovat heslo',
    searchUsers: 'Hledat uživatele...',
    userCreated: 'Uživatel byl úspěšně vytvořen',
    userUpdated: 'Uživatel byl úspěšně aktualizován',
    userDeleted: 'Uživatel byl úspěšně smazán',
    selectNation: 'Vyberte stát',
    mustChangePassword: 'Vyžadovat změnu hesla při příštím přihlášení',
    flagImage: 'Obrázek vlajky',
    exportUsers: 'Exportovat uživatele',
    importUsers: 'Importovat uživatele',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Prostředky',
    createAsset: 'Vytvořit prostředek',
    editAsset: 'Upravit prostředek',
    deleteAsset: 'Smazat prostředek',
    assetName: 'Název prostředku',
    assetType: 'Typ prostředku',
    capacitySeated: 'Kapacita (sedící)',
    capacityLying: 'Kapacita (ležící)',
    capacityIntensive: 'Kapacita (intenzivní)',
    owner: 'Vlastník',
    operator: 'Provozovatel',
    baseLocation: 'Základní umístění',
    range: 'Dosah',
    speed: 'Rychlost',
    noAssets: 'Nebyly nalezeny žádné prostředky',
    confirmDelete: 'Opravdu chcete tento prostředek smazat?',
    searchAssets: 'Hledat prostředky...',
    assetCreated: 'Prostředek byl úspěšně vytvořen',
    assetUpdated: 'Prostředek byl úspěšně aktualizován',
    assetDeleted: 'Prostředek byl úspěšně smazán',
    exportAssets: 'Exportovat prostředky',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Uzly',
    startPoints: 'Výchozí body',
    createHub: 'Vytvořit uzel',
    editHub: 'Upravit uzel',
    deleteHub: 'Smazat uzel',
    hubName: 'Název uzlu',
    hubType: 'Typ uzlu',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Vstupní uzel',
    airport: 'Letiště',
    seaport: 'Přístav',
    railStation: 'Železniční stanice',
    roadPoint: 'Silniční bod',
    ucpmClassification: 'Klasifikace UCPM',
    icaoCode: 'Kód ICAO',
    iataCode: 'Kód IATA',
    noHubs: 'Nebyly nalezeny žádné uzly',
    confirmDelete: 'Opravdu chcete tento uzel smazat?',
    searchHubs: 'Hledat uzly...',
    nationAssignment: 'Přiřazení státu',
    assignNations: 'Přiřadit státy',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Zdravotnická zařízení',
    createFacility: 'Vytvořit zařízení',
    editFacility: 'Upravit zařízení',
    deleteFacility: 'Smazat zařízení',
    facilityName: 'Název zařízení',
    facilityType: 'Typ zařízení',
    hospitalName: 'Název nemocnice',
    bedCapacity: 'Kapacita lůžek',
    specialties: 'Specializace',
    availableBeds: 'Dostupná lůžka',
    totalBeds: 'Celkový počet lůžek',
    contactPerson: 'Kontaktní osoba',
    noFacilities: 'Nebyla nalezena žádná zdravotnická zařízení',
    confirmDelete: 'Opravdu chcete toto zařízení smazat?',
    searchFacilities: 'Hledat zařízení...',
    hubNationAssignment: 'Přiřazení státu k uzlu',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Jízdní řády',
    createSchedule: 'Vytvořit jízdní řád',
    editSchedule: 'Upravit jízdní řád',
    deleteSchedule: 'Smazat jízdní řád',
    scheduleName: 'Název jízdního řádu',
    scheduleType: 'Typ jízdního řádu',
    recurring: 'Opakující se',
    oneTime: 'Jednorázový',
    frequency: 'Frekvence',
    daily: 'Denně',
    weekly: 'Týdně',
    startDate: 'Datum zahájení',
    endDate: 'Datum ukončení',
    departureTime: 'Čas odjezdu',
    arrivalTime: 'Čas příjezdu',
    stops: 'Zastávky',
    addStop: 'Přidat zastávku',
    noSchedules: 'Nebyly nalezeny žádné jízdní řády',
    bookings: 'Rezervace',
    timeline: 'Časová osa',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Oznámení',
    markAllRead: 'Označit vše jako přečtené',
    markAsRead: 'Označit jako přečtené',
    markAsUnread: 'Označit jako nepřečtené',
    noNotifications: 'Žádná oznámení',
    viewAll: 'Zobrazit všechna oznámení',
    settings: 'Nastavení oznámení',
    emailNotifications: 'E-mailová oznámení',
    inAppNotifications: 'Oznámení v aplikaci',
    notifyOn: 'Upozornit mě na',
    requestCreated: 'Nová žádost',
    requestPublished: 'Žádost publikována',
    requestClosed: 'Žádost uzavřena',
    requestCompleted: 'Žádost dokončena',
    commentAdded: 'Nový komentář',
    offerReceived: 'Nabídka přijata',
    offerAccepted: 'Nabídka schválena',
    statusChanged: 'Změna stavu',
    selectionStarted: 'Výběr zahájen',
    missionCreated: 'Transport vytvořen',
    missionStatusUpdated: 'Transport aktualizován',
    transportPartnerNamed: 'Transportní partner',
    transportExtensionReceived: 'Rozšíření transportu',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Nastavení',
    general: 'Obecné',
    system: 'Systém',
    email: 'E-mail',
    sync: 'Synchronizace',
    security: 'Zabezpečení',
    appearance: 'Vzhled',
    systemName: 'Název systému',
    systemEmail: 'Systémový e-mail',
    maintenanceMode: 'Režim údržby',
    readOnlyMode: 'Režim pouze ke čtení',
    emailEnabled: 'E-mail povolen',
    smtpHost: 'SMTP hostitel',
    smtpPort: 'SMTP port',
    smtpUser: 'SMTP uživatel',
    smtpPassword: 'SMTP heslo',
    senderEmail: 'E-mail odesílatele',
    senderName: 'Jméno odesílatele',
    testEmail: 'Odeslat testovací e-mail',
    syncEnabled: 'Synchronizace povolena',
    syncUrl: 'URL synchronizace',
    syncApiKey: 'API klíč synchronizace',
    settingsSaved: 'Nastavení bylo úspěšně uloženo',
    helpdesk: 'Podpora',
    helpdeskTitle: 'Název podpory',
    helpdeskEmail: 'E-mail podpory',
    helpdeskPhone: 'Telefon podpory',
    helpdeskInfo: 'Informace o podpoře',
    realLifeSupport: 'Podpora v reálném životě',
    trainingMode: 'Režim výcviku',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Auditní protokol',
    action: 'Akce',
    user: 'Uživatel',
    target: 'Cíl',
    details: 'Podrobnosti',
    timestamp: 'Časové razítko',
    ipAddress: 'IP adresa',
    noLogs: 'Nebyly nalezeny žádné auditní záznamy',
    searchLogs: 'Hledat záznamy...',
    filterByAction: 'Filtrovat podle akce',
    filterByUser: 'Filtrovat podle uživatele',
    exportLogs: 'Exportovat záznamy',
    exportCsv: 'Exportovat CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Řízení cvičení',
    currentDay: 'Aktuální den',
    exerciseDay: 'Den cvičení',
    nextDay: 'Další den',
    previousDay: 'Předchozí den',
    resetExercise: 'Obnovit cvičení',
    startExercise: 'Zahájit cvičení',
    endExercise: 'Ukončit cvičení',
    dayReset: 'Obnovení dne',
    confirmReset: 'Opravdu chcete obnovit den cvičení? Tím se vymažou všechna data aktuálního dne.',
    resetInProgress: 'Probíhá obnovení...',
    maintenanceMode: 'Režim údržby',
    enableMaintenance: 'Zapnout údržbu',
    disableMaintenance: 'Vypnout údržbu',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Synchronizace dat',
    syncStatus: 'Stav synchronizace',
    lastSync: 'Poslední synchronizace',
    pendingItems: 'Čekající položky',
    syncNow: 'Synchronizovat nyní',
    syncing: 'Synchronizace...',
    syncSuccess: 'Synchronizace úspěšně dokončena',
    syncFailed: 'Synchronizace se nezdařila',
    outbox: 'Odchozí',
    inbox: 'Příchozí',
    configuration: 'Konfigurace',
    targetUrl: 'Cílová URL',
    apiKey: 'API klíč',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mapa',
    layers: 'Vrstvy',
    requests: 'Žádosti',
    hubs: 'Uzly',
    facilities: 'Zařízení',
    routes: 'Trasy',
    showAll: 'Zobrazit vše',
    hideAll: 'Skrýt vše',
    zoomIn: 'Přiblížit',
    zoomOut: 'Oddálit',
    resetView: 'Obnovit zobrazení',
    satellite: 'Satelit',
    terrain: 'Terén',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Mapové dlaždice jsou servírovány lokálně',
    tilesOnline: 'Mapové dlaždice jsou načítány z online serverů',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistiky',
    overview: 'Přehled',
    requestsByStatus: 'Žádosti podle stavu',
    requestsByCategory: 'Žádosti podle kategorie',
    requestsByNation: 'Žádosti podle státu',
    offersByStatus: 'Nabídky podle stavu',
    patientsByCondition: 'Pacienti podle stavu',
    transportsByStatus: 'Transporty podle stavu',
    timeline: 'Časová osa',
    totalRequests: 'Celkem žádostí',
    totalOffers: 'Celkem nabídek',
    totalPatients: 'Celkem pacientů',
    totalTransports: 'Celkem transportů',
    averageResponseTime: 'Průměrná doba odezvy',
    completionRate: 'Míra dokončení',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistiky cvičení',
    overview: 'Přehled',
    byCategory: 'Podle kategorie',
    byNation: 'Podle státu',
    byDay: 'Podle dne',
    totalPatientsMoved: 'Celkem přepravených pacientů',
    totalRequestsProcessed: 'Celkem zpracovaných žádostí',
    averageProcessingTime: 'Průměrná doba zpracování',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagram toku',
    sankey: 'Sankey',
    nodeGraph: 'Uzlový graf',
    refresh: 'Obnovit',
    noData: 'Žádná data o toku nejsou k dispozici',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'O systému',
    version: 'Verze',
    systemInfo: 'Informace o systému',
    buildDate: 'Datum sestavení',
    environment: 'Prostředí',
    description: 'ARCOS — Pokročilý systém komunikace žádostí',
    subtitle: 'Asistence obětem a zdravotnické operace',
    whatIsArcos: 'Co je ARCOS? – Vysvětlení pro účastníky cvičení',
    arcosDesc1: 'ARCOS je digitální nástroj používaný v tomto cvičení k podpoře a strukturování mezinárodní komunikace, žádostí a koordinačních procesů mezi zúčastněnými aktéry.',
    arcosDesc2: 'ARCOS poskytuje zjednodušenou, na cvičení orientovanou reprezentaci základních principů těchto systémů.',
    arcosUsedFor: 'Během cvičení se ARCOS používá k reprezentaci typických procesů jako:',
    arcosUsedForItem1: 'podávání a správa žádostí o pomoc,',
    arcosUsedForItem2: 'koordinace a reagování na nabídky podpory od jiných národů,',
    arcosUsedForItem3: 'sledování stavu a průběhu žádostí,',
    arcosUsedForItem4: 'a reprezentace zjednodušených transportních nebo evakuačních pracovních postupů.',
    arcosDesc3: 'Pracovní postupy v ARCOS jsou záměrně zjednodušeny a přizpůsobeny specifickým výcvikovým cílům cvičení.',
    arcosDesc4: 'Cílem ARCOS není simulovat dokonalý nebo úplný reálný systém.',
    arcosDesc5: 'Pokud se některé prvky liší od reálných postupů, které znáte, je to očekávané.',
    facilitatedBy: 'Za podpory MMCC-E',
    dhcInitiative: 'Digital Health Corner (DHC) je společná iniciativa:',
    dhcAuthor1: 'Sven Giegerich — Německé ozbrojené síly',
    dhcAuthor2: 'Mohamad Haji — Belgická obrana',
    dhcConviction: 'Zrozená z přesvědčení, že inovace prosperuje tam, kde se vášeň setkává s pragmatismem.',
    dhcInspired: 'Inspirováni počátečním podnětem MMCC-E jsme se vydali vytvářet jednoduchá, ale účinná řešení.',
    dhcLove: 'Děláme to, protože milujeme svou práci a věříme, že digitální nápady mohou přetvořit spolupráci ve vojenském zdravotnictví.',
    dhcOpen: 'DHC je otevřená platforma: bez hierarchií, otevřená nápadům, poháněná zvědavostí.',
    dhcClosing: 'Digital Health Corner – kde se zvědavost setkává se spoluprací.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentace',
    gettingStarted: 'Začínáme',
    userGuide: 'Uživatelská příručka',
    faq: 'Časté dotazy',
    troubleshooting: 'Řešení problémů',
    apiReference: 'API reference',
    downloadTemplate: 'Stáhnout šablonu',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Import pacientů',
    uploadFile: 'Nahrát soubor',
    selectFile: 'Vybrat soubor',
    preview: 'Náhled',
    importNow: 'Importovat nyní',
    importing: 'Importování...',
    importSuccess: '{{count}} pacientů bylo úspěšně importováno',
    importFailed: 'Import se nezdařil',
    downloadTemplate: 'Stáhnout šablonu',
    dragDrop: 'Přetáhněte soubor sem nebo klikněte pro výběr',
    supportedFormats: 'Podporované formáty: XLSX, XLS, CSV',
    rowsFound: '{{count}} nalezených řádků',
    validRows: '{{count}} platných řádků',
    invalidRows: '{{count}} neplatných řádků',
    duplicateRows: '{{count}} duplicitních řádků',
    previewData: 'Náhled dat',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Plánování transportu',
    planRoute: 'Naplánovat trasu',
    routeBuilder: 'Sestavení trasy',
    addWaypoint: 'Přidat průjezdní bod',
    removeWaypoint: 'Odebrat průjezdní bod',
    estimatedDuration: 'Odhadovaná doba trvání',
    distance: 'Vzdálenost',
    selectVehicle: 'Vybrat vozidlo',
  },

  transportBooking: {
    title: 'Rezervace transportu',
    bookTransport: 'Rezervovat transport',
    availableSlots: 'Dostupné termíny',
    bookingConfirmed: 'Rezervace potvrzena',
    cancelBooking: 'Zrušit rezervaci',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Plánování kapacit',
    totalCapacity: 'Celková kapacita',
    usedCapacity: 'Využitá kapacita',
    availableCapacity: 'Dostupná kapacita',
    utilizationRate: 'Míra využití',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Šablony prostředků',
    dayTemplates: 'Denní šablony',
    createTemplate: 'Vytvořit šablonu',
    editTemplate: 'Upravit šablonu',
    deleteTemplate: 'Smazat šablonu',
    templateName: 'Název šablony',
    applyTemplate: 'Použít šablonu',
    noTemplates: 'Nebyly nalezeny žádné šablony',
    confirmDelete: 'Opravdu chcete tuto šablonu smazat?',
    confirmApply: 'Opravdu chcete použít tuto šablonu? Tím se přepíší stávající data.',
    exportTemplates: 'Exportovat šablony',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Ticker oznámení',
    createAnnouncement: 'Vytvořit oznámení',
    editAnnouncement: 'Upravit oznámení',
    deleteAnnouncement: 'Smazat oznámení',
    message: 'Zpráva',
    startTime: 'Čas zahájení',
    endTime: 'Čas ukončení',
    active: 'Aktivní',
    noAnnouncements: 'Žádná oznámení',
    confirmDelete: 'Opravdu chcete toto oznámení smazat?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Hledat...',
      noResults: 'Nebyly nalezeny žádné výsledky',
      showing: 'Zobrazeno {{from}} až {{to}} z {{total}}',
      rowsPerPage: 'Řádků na stránku',
      previousPage: 'Předchozí stránka',
      nextPage: 'Další stránka',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Potvrdit',
      cancel: 'Zrušit',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Neuložené změny',
      message: 'Máte neuložené změny. Opravdu chcete opustit tuto stránku?',
      stay: 'Zůstat na stránce',
      leave: 'Opustit stránku',
    },
    // EmptyState
    emptyState: {
      noData: 'Žádná data nejsou k dispozici',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Něco se pokazilo',
      message: 'Došlo k neočekávané chybě. Zkuste prosím obnovit stránku.',
      retry: 'Zkusit znovu',
    },
    // ExportButton
    exportButton: {
      export: 'Exportovat',
      exporting: 'Exportování...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Tisk',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Koncept',
      review: 'Přezkum',
      published: 'Publikováno',
      selection: 'Výběr',
      inTransit: 'Na cestě',
      completed: 'Dokončeno',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Online instance',
      message: 'Režim pouze ke čtení. Data jsou synchronizována z primárního serveru.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Prohlížíte jako',
      loggedInAs: 'přihlášen jako {{nation}}',
      returnTo: 'Vrátit se k {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Hledat stránky, žádosti, transporty...',
      searching: 'Hledání...',
      noResults: 'Žádné výsledky pro „{{query}}"',
      navigate: 'Navigovat',
      select: 'Vybrat',
      close: 'Zavřít',
      pages: {
        dashboard: 'Přehled',
        requests: 'Žádosti',
        transports: 'Transporty',
        map: 'Mapa',
        myPatients: 'Moji pacienti',
        flowDiagram: 'Diagram toku',
        statistics: 'Statistiky',
        assets: 'Prostředky',
        startPoints: 'Výchozí body / Uzly',
        treatmentFacilities: 'Zdravotnická zařízení',
        users: 'Uživatelé',
        settings: 'Nastavení',
        auditLogs: 'Auditní protokol',
        exerciseControl: 'Řízení cvičení',
        dataSync: 'Synchronizace dat',
        patientImport: 'Import pacientů',
        notifications: 'Oznámení',
        documentation: 'Dokumentace',
      },
      actions: {
        importPatientsJson: 'Importovat Pacientů (JSON)',
        importPatientsExcel: 'Importovat Pacientů (Excel)',
        importUsers: 'Importovat Uživatelů (Excel)',
        importAssetTemplates: 'Importovat Šablony prostředků (Excel)',
        importDayTemplates: 'Importovat Záznamy denní šablony (Excel)',
        exportRequests: 'Exportovat Žádostí (Excel)',
        exportPatients: 'Exportovat Pacientů (Excel)',
        exportUsers: 'Exportovat Uživatelů (Excel)',
        exportCredentials: 'Exportovat Přihlašovací údaje (PDF)',
        exportAuditExcel: 'Exportovat Protokol auditu (Excel)',
        exportAuditPdf: 'Exportovat Protokol auditu (PDF)',
        pagePatientImport: 'Stránka importu pacientů',
        pageRequestDetail: 'Stránka detailu žádosti',
        pageUsers: 'Stránka správy uživatelů',
        pageAssetTemplates: 'Stránka šablon prostředků',
        pageDayTemplates: 'Stránka denních šablon',
        pageRequests: 'Stránka seznamu žádostí',
        pageAuditLogs: 'Stránka protokolu auditu',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Relace brzy vyprší',
      message: 'Vaše relace vyprší za <strong>{{time}}</strong>. Uložte prosím svou práci a znovu se přihlaste.',
      dismiss: 'Zavřít',
      logoutNow: 'Odhlásit nyní',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Vyberte 4 časová pásma',
      configure: 'Nastavit časová pásma',
      reset: 'Obnovit',
      apply: 'Použít',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Vybrat umístění',
      latitude: 'Zeměpisná šířka',
      longitude: 'Zeměpisná délka',
      clickToSelect: 'Klikněte na mapu pro výběr umístění',
    },
    // Modal
    modal: {
      close: 'Zavřít',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Domů',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Údržba systému',
    message: 'Systém je obnovován pro další den cvičení. Prosím vyčkejte, než bude proces dokončen.',
    autoRefresh: 'Tato stránka se automaticky obnoví, jakmile bude systém opět dostupný.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Alespoň 10 znaků',
    uppercase: '1 velké písmeno',
    lowercase: '1 malé písmeno',
    digit: '1 číslice',
    special: '1 speciální znak',
  },
};

export default cs;
